import axiosInstance from '@/utils/api.js'

var state = {
  document: []
}

var getters = {
  DOCUMENT: (state) => {
    return state.document
  }
}

var mutations = {
  SET_DOCUMENT: (state, payload) => {
    state.document = payload
  }
}

var actions = {
  GET_DOCUMENT: (context, payload) => {
    return axiosInstance.get('/users/documents?doc_type=5&file_type=1' + '&user_id=' + payload.user_id + '&base_id=' + payload.base_id, {responseType: 'blob'})
  },
  GET_DOCUMENT_USER: (context, payload) => {
    return axiosInstance.get('/users/documents?doc_type=3&file_type=' + payload.file_type + '&user_id=' + payload.user_id + '&base_id=' + payload.base_id, {responseType: 'blob'})
  },
  GET_REPORT_DOCUMENT: (context, payload) => {
    return axiosInstance.get('/users/documents?doc_type=' + payload.doc_type + '&file_type=' + payload.file_type + '&user_id=' + payload.user_id + '&base_id=' + payload.base_id, {responseType: 'blob'})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/documents.js